import { withFocusRing } from "@components/Accessibility/FocusRing/FocusRing";
import { Icon } from "@components/Icon";
import { ClearAll } from "@usereactify/search";
import React from "react";
import tw from "twin.macro";

const ClearAllButton = withFocusRing(
  tw.button`flex relative items-center justify-center text-body leading-input py-1 cursor-pointer`,
);
const ClearAllIcon = tw(Icon)`block my-auto pl-1`;
const ClearAllText = tw.span`block`;

const RenderClearAll = (props: { clearAll: () => void }) => {
  return (
    <ClearAllButton role="ClearAllButton" onClick={props.clearAll}>
      <ClearAllText>Clear All</ClearAllText>
      <ClearAllIcon name="close" size="xxs" />
    </ClearAllButton>
  );
};

export const FilterSectionClearAll = () => {
  return <ClearAll render={RenderClearAll} />;
};
